import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LayoutDashboard, Coins, CreditCard, Bell, Settings, X } from 'lucide-react'
import { cn } from '../../lib/utils'

interface SidebarProps {
  isOpen: boolean
  onClose: () => void
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const { t } = useTranslation()

  const navItems = [
    { path: '/', icon: LayoutDashboard, label: t('nav.dashboard') },
    { path: '/points', icon: Coins, label: t('nav.points') },
    { path: '/payments', icon: CreditCard, label: t('nav.payments') },
    { path: '/notifications', icon: Bell, label: t('nav.notifications') },
    { path: '/settings', icon: Settings, label: t('nav.settings') },
  ]

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed top-16 left-0 bottom-0 w-64 z-50',
          'bg-light-card dark:bg-dark-card',
          'border-r border-light-border dark:border-dark-border',
          'transition-transform duration-300 ease-in-out',
          'md:translate-x-0',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        {/* Mobile close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 md:hidden hover:bg-light-bg-secondary dark:hover:bg-dark-bg-secondary rounded-md"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Navigation */}
        <nav className="p-4 space-y-1 mt-8 md:mt-0">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 px-4 py-3 rounded-lg transition-colors',
                  'hover:bg-light-bg-secondary dark:hover:bg-dark-bg-secondary',
                  isActive
                    ? 'bg-primary/10 text-primary font-medium'
                    : 'text-light-text-secondary dark:text-dark-text-secondary'
                )
              }
            >
              <item.icon className="w-5 h-5" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-light-border dark:border-dark-border">
          <div className="text-center text-xs text-light-text-muted dark:text-dark-text-muted">
            <p>ScreenEagle v1.0.0</p>
          </div>
        </div>
      </aside>
    </>
  )
}
